import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import AnalyticsTracker from "./lib/AnalyticsTracker";
import Home from "./pages/Home";
import ResultsPage from "./pages/ResultsPage";
import ServicePage from "./pages/ServicePage";
import CompetitionApply from "./pages/CompetitionApply";
import BlogPage from "./pages/BlogPage";
import StoresPage from "./pages/StoresPage";
import ThankYou from "./pages/ThankYou";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import WatchPage from "./pages/WatchPage";
import SalesLetterPage from "./pages/SalesLetterPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/matrix" element={<Home />} />
          <Route path="/matrix/results/:resultId" element={<ResultsPage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/services/competition-coaching/apply" element={<CompetitionApply />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/stores" element={<StoresPage />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/full-stack-coaching-letter" element={<SalesLetterPage />} />
          <Route path="/watch" element={<WatchPage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy.html" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms.html" element={<Terms />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
